export enum CompanyStatusEnum {
    Suspended = 0,
    Active = 1,
    All = 2
}